<template>
  <v-card class="text-xs-center">
    <setZoneTable/>
  </v-card>
</template>

<script>

import setZoneTable from "@/components/back-office/SetApp/Zone/SetZoneTable";
export default {
  components: {
    setZoneTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href:  "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "App setting",
        disabled: false,
        href:
           "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/food/setpromotionbanner"
      },
      {
        text: "Set app",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
